import React, { ReactElement } from 'react';
import './style.scss';
import { IconName, findIcon } from 'utils/handleIcon';
import { TwoSelections } from 'views/mutual/inputRadio';
import { CardLabel } from 'views/mutual/questionCard';
import { IconSize, SvgIcon } from 'views/mutual/svgIcon';
import { TemplateProps } from 'views/templates/accountOpen/common';
import { InputTemplate, MaskType } from 'views/templates/module/inputTemplate';

export const MailAddressQuestionTop = ({ isUpdate }: TemplateProps) => {
  const icon = findIcon(IconName.passport);
  return (
    <div className="corporate-account-open">
      <div className="MailFormQuestionTop">
        <CardLabel
          letter={<><>&#10103;</>取引担当者さまメールアドレス</>}
          help={
            <>
              ※代表者さまを取引担当者さまとする場合は、代表者さまの情報をご入力ください。
            </>
          }
        />
      </div>
    </div>
  );
};

interface mailQuestionBottomProps {
  value: string | undefined;
  onChange: (value: string) => void;
  error: string | undefined;
  isUpdate: boolean;
}

export const MailAddressQuestionBottom = (props: mailQuestionBottomProps) => {
  return (
    <div className="corporate-account-open">
      <div className="MailFormQuestionBottom">
        <div className='MailFormQuestionBottom_label'>
          <a
            className="accountOpenTemplate_input_wrapper_link"
            href={process.env.REACT_APP_ELECTORIC_GENERAL_TERMS_CONDITION_URL}
            target="_blank"
            rel="noopener noreferrer"
          >
            FPGオンライン取引・電子署名取引一般規約
          </a>
          に定める本件電子署名サービスに使用するメールアドレス（指定アドレス）として届け出ます。
        </div>
        <InputTemplate
          type="text"
          placeholder="例：example@example.com"
          masked={props.isUpdate ? { type: MaskType.End, displayedCount: 4 } : undefined}
          {...props}
        />
      </div>
    </div>
  );
};
